'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _carouselModal = require('./carousel-modal');

var _carouselModal2 = _interopRequireDefault(_carouselModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImagePreview = function (_React$Component) {
    _inherits(ImagePreview, _React$Component);

    function ImagePreview(props) {
        _classCallCheck(this, ImagePreview);

        var _this = _possibleConstructorReturn(this, (ImagePreview.__proto__ || Object.getPrototypeOf(ImagePreview)).call(this, props));

        _this.handleHideModal = function () {
            _this.setState({ view: { showModal: false } });
        };

        _this.handleShowModal = function () {
            if (!_this.props.imageAvailable) {
                return;
            }
            _this.setState({ view: { showModal: true } });
        };

        _this.hideBrokenIcon = function () {
            console.log('Called hide broken icon');
            _this.imgPrev.style.visibility = 'collapse';
        };

        _this.image = function (idx) {
            var defaultStyle = { cursor: "pointer" };
            var index = 0;
            var mediaArray = [];
            if (_this.props.item.mediaArray && _this.props.item.mediaArray.length > idx) {
                index = idx;
            }

            var link = "";
            if (_this.props.item.mediaArray && _this.props.item.mediaArray[index]) {
                link = _this.props.item.mediaArray[index].url;
                mediaArray = _this.props.item.mediaArray;
            }

            var carouselModal = _react2.default.createElement(_carouselModal2.default, {
                handleHideModal: _this.handleHideModal,
                itemName: _this.props.item.itemName,
                itemDesc: _this.props.item.itemDescription,
                itemId: _this.props.item.objectId,
                imgUrl: link,
                mediaArray: mediaArray
            });

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    {
                        className: 'image-preview',
                        onMouseEnter: _this.handleMouseEnter,
                        onMouseLeave: _this.handleMouseLeave
                    },
                    _react2.default.createElement('img', {
                        src: link,
                        ref: function ref(img) {
                            return _this.imgPrev = img;
                        },
                        title: _this.props.item.itemName,
                        alt: _this.props.item.itemName,
                        className: 'align-center group list-group-image',
                        style: defaultStyle,
                        onError: _this.hideBrokenIcon,
                        onClick: _this.props.showItemOption
                    })
                ),
                _this.state.view.showModal ? carouselModal : null
            );
        };

        _this.icon = function () {
            return _react2.default.createElement('span', { className: 'fa fa-search-plus fa-default' });
        };

        _this.handleMouseEnter = function () {
            _this.setState({ hovering: true });
        };

        _this.handleMouseLeave = function () {
            _this.setState({ hovering: false });
        };

        _this.state = {
            hovering: false,
            view: { showModal: false }
        };
        return _this;
    }

    _createClass(ImagePreview, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                this.image(0)
            );
        }
    }]);

    return ImagePreview;
}(_react2.default.Component);

exports.default = ImagePreview;


//////////////////
// WEBPACK FOOTER
// ./src/components/generic/image-handling/image-preview.jsx
// module id = 476
// module chunks = 0